<template>
    <div :class="{'digital-wraper': !isFullscreen,'digital-wraper-fullscreen':isFullscreen}">
        <div class="digital-left" v-if="menubarActive!=='1'&&menubarActive!=='5'">
            <div class="left-title">地块列表</div>
            <div class="left-search-input">
                 <el-input
                    placeholder="请输入编号/项目名称"
                    v-model="inputvalues"
                    clearable
                    @clear="clearSearch"
                    @change="handleSearch">
                </el-input>
                <div class="btn-search" @click="handleSearch"></div>
            </div>
            <div v-if="searchList" class="search-list">
                <div class="result" v-for="(item,index) in searchList" :key="index" @click="handleTreeClick(item)">
                    <span class="lotnumber" v-html="getSearchHtml(`${item.lotNumber}`)"></span>
                    <span class="name" v-html="getSearchHtml(`${item.projectName}`)"></span>
                </div>
            </div>
            <div ref="treeScroll" v-else class="left-tree">
                <el-tree
                    v-if="showTree"
                    ref="tree"
                    class="tree"
                    :data="treeData"
                    :props="defaultProps"
                    :accordion="true"
                    node-key="key"
                    :default-expanded-keys="treeExpandedKeys"
                    @node-click="handleNodeClick">
                    <div class="custom-tree-node" slot-scope="{ node }">
                        <span class="lotnumber">{{ node.label.split(' ')[0] }}</span>
                        <span class="name">{{ node.label.split(' ')[1] }}</span>
                    </div>
                </el-tree>
            </div>
            
        </div>
        <div class="digital-right" v-if="menubarActive!=='1'&&menubarActive!=='5'">
            <BuildSituation v-if="menubarActive==='0'"></BuildSituation>
            <FunctionalZone v-if="menubarActive==='2'"></FunctionalZone>
            <Pipeline v-if="menubarActive==='3'" :lotList="listData"></Pipeline>
            <Region v-if="menubarActive==='4'"></Region>
        </div>
        <PlanningMap v-if="menubarActive==='1'"></PlanningMap>
        <ReportTable v-if="menubarActive==='5'"></ReportTable>
        <div class="digital-menubar">
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':menubarActive==='0'}" @click="handleTabClick('0')">建设情况</div>
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':menubarActive==='1'}" @click="handleTabClick('1')">规划图</div>
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':menubarActive==='2'}" @click="handleTabClick('2')">功能分区</div>
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':menubarActive==='3'}" @click="handleTabClick('3')">市政管线</div>
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':menubarActive==='4'}" @click="handleTabClick('4')">地域归属</div>
            <div class="tab-item" v-bind:class="{'tab-item-active font-color':menubarActive==='5'}" @click="handleTabClick('5')">指标总表</div>
        </div>
        <div v-show="menubarActive!=='1'&&menubarActive!=='5'" class="digital-toolbar">
            <div class="tool-item" @click="changeViewpoint(false)">
                <img v-if="isShow2D" src="../../assets/images/digital/tool-2D.png" />
                <img v-else src="../../assets/images/digital/tool-3D.png" />
            </div>
            <div class="tool-item" v-bind:class="{'tool-item1': !isShowBim}" @click="showBim">
                <img src="../../assets/images/digital/tool-building.png" />
            </div>
        </div>
        <DetailZone v-if="menubarActive==='2'&&selectedTree" :itemData="selectedTree"></DetailZone>
        <DetailInfo v-if="menubarActive!=='2'&&selectedTree" :itemData="selectedTree"></DetailInfo>
        <PreviewDialog v-if="previewIndex>-1" :currIndex="previewIndex" :previewList="previewList"></PreviewDialog>
        <GISCanvas ref="gisContent" v-show="menubarActive!=='5'&&menubarActive!=='1'" :menubarActive="menubarActive" :isShowBim="isShowBim" :lotList="listData"></GISCanvas>
    </div>
</template>

<script>
import '../digitalGeneralCommon/DragPanel.vue'
import BuildSituation from '../digitalGeneralCommon/BuildSituation'
import PlanningMap from '../digitalGeneralCommon/PlanningMap.vue'
import FunctionalZone from '../digitalGeneralCommon/FunctionalZone'
import Pipeline from '../digitalGeneralCommon/Pipeline'
import Region from '../digitalGeneralCommon/Region'
import ReportTable from '../digitalGeneralCommon/ReportTable'
import DetailInfo from '../digitalGeneralCommon/DetailInfo'
import DetailZone from '../digitalGeneralCommon/DetailZone'
import PreviewDialog from '../digitalGeneralCommon/PreviewDialog'
import GISCanvas from '../digitalGeneralCommon/GIS.vue'
import { mapActions } from 'vuex'
export default {
  name: "DigitalGeneralDrawing",
  components: {
    BuildSituation,
    PlanningMap,
    FunctionalZone,
    Pipeline,
    Region,
    ReportTable,
    DetailZone,
    DetailInfo,
    PreviewDialog,
    GISCanvas
  },
  data() {
    return {
        inputvalues: '',
        keywords: '', //查询条件
        listData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        showTree: true, //控制tree渲染
        treeExpandedKeys: [], //地块列表展开节点
        menubarActive: '0', //底部菜单切换
        isShow2D: true, //切换2D顶视角和3D视角
        isShowBim: true, //场景区建筑模型显示/隐藏
        selectedTree: null,  //地块选中
        previewIndex: -1, //预览指针
        previewList: null, //详情预览列表
    };
  },
  props: {
    isFullscreen: {
        type: Boolean,
        default: () => {
            return true;
        }
    },
  },
  created() {
    this.getListAxios()
    this.getEditAuthAxios()
  },
  computed: {
    treeData() { //地块列表树结构
        let tree = {}
        for(let item of this.listData) {
            if(!tree[item.functionZone]) {
                let arr = [];
                arr.push(item);
                tree[item.functionZone] = arr;
            }else {
                tree[item.functionZone].push(item)
            }
        }
        let data = []
        for(let key in tree) {
            let children = tree[key]
            data.push({
                key: key,
                label: key,
                children: children.map(item => { 
                    return {
                        key: item.lotNumber,
                        label: `${item.lotNumber} ${item.projectName?item.projectName:'-'}`, 
                        lotNumber: item.lotNumber
                    } 
                })
            })
        }
        // console.log(data)
        return data;
    },
    searchList() { //地块搜索列表
        if(this.keywords) {
            let filterData = this.listData.filter( item => item.lotNumber.indexOf(this.keywords.toUpperCase())>-1 || item.projectName&&item.projectName.indexOf(this.keywords)>-1)
            return filterData
        } else {
            return null
        }
    }
  },
  methods: {
    ...mapActions('gisData', ['setAuthEditAsync']),
    //获取编辑权限
    getEditAuthAxios() {
      let _this = this;
      let url = `${window.pubilc_config.digitalServerurl}/v1/digital/auth/edit-auth`
      this.$common.getTokenRequest()
        .get(url)
        .then(res => {
          if (res.status === 200) {
            let data = res.data;
            if(data.code === 0) {
               _this.setAuthEditAsync(data.data.can);
            }
          }
        }).catch(err=>{
          console.log(err,'===/v1/digital/auth/edit-auth')
        })
    },
    //获取地块列表
    getListAxios() {
      let _this = this;
      let url = `${window.pubilc_config.digitalServerurl}/v1/digital/lot/list`
      this.$common.getTokenRequest()
        .get(url)
        .then(res => {
          if (res.status === 200) {
            let data = res.data;
            if(data.code === 0) {
                _this.listData = data.data;
            }
          }
        }).catch(err=>{
          console.log(err,'===/v1/digital/lot/list')
        })
    },
    //搜索
    handleSearch() {
        this.keywords = this.inputvalues
    },
    //清空搜索
    clearSearch() {
        this.keywords = ''
    },
    //搜索字体处理
    getSearchHtml(text) {
        if (this.keywords.trim()) {
        //   let text = data.lotNumber + " " + data.projectName
        //   const words = text.split('')
        //   const keys = this.keywords.toUpperCase().trim().replace(/\s*/g, '').split('')
        //   keys.forEach(key => {
        //     for (let i = 0; i < words.length; i++) {
        //       if (words[i] === key) {
        //         words[i] = `<span style="color: #2899FF;">${key}</span>`
        //       }
        //     }
        //     text = words.join('')
        //   })
        //   return text;
          let keys = this.keywords.toUpperCase().trim()
          let words = text.split(keys)
          let style = `<span style="color: #2899FF;">${keys}</span>`
          return words.join(style);
        }
    },
    //左侧地块列表点击
    handleNodeClick(data) {
        this.handleTreeClick(data)
    },
    handleTreeClick(data, isFromMap) {
        // console.log(data)
        if(!data.children) {
            this.selectedTree = data
            if(!isFromMap) {
               this.$refs.gisContent.doClickLot(data.lotNumber)
            }
        }
        if(data.children) {
            if(this.treeExpandedKeys.indexOf(data.key) > -1) {
                this.treeExpandedKeys = []
            } else {
                this.treeExpandedKeys = [data.key]
            }
        }
        if(isFromMap) {
            let info = this.listData.find( item => item.lotNumber === data.lotNumber)
            if(info) {
                this.treeExpandedKeys = [info.functionZone]
            }
            this.showTree = false //解决不收起问题
            let _this = this
            this.$nextTick(()=>{
                _this.showTree = true;
                setTimeout(_this.setTreeSelectedKey, 200 )
                
            });
        }
    },
    //设置选中tree
    setTreeSelectedKey() {
        this.$refs.tree.setCurrentKey(this.selectedTree.key);
        this.$refs.treeScroll.scrollTop = 400
    },
    //清除地块选中
    clearSelectedTree() {
        this.$refs.gisContent && this.$refs.gisContent.clearLotTwinkle();
        this.selectedTree = null;
        this.$refs.tree && this.$refs.tree.setCurrentKey(null);
        if(this.$refs.treeScroll) {
            this.$refs.treeScroll.scrollTop = 0;
        }
    },
    //底部菜单点击
    handleTabClick(data) {
        this.clearSelectedTree()
        this.menubarActive = data
        if(data==='0') {
            this.isShowBim = true
        } else {
            this.isShowBim = false
        }
    },
    //切换2D顶视角和3D视角
    changeViewpoint(isRotate) {
        if(isRotate) {
            if(this.isShow2D) {
                this.isShow2D = false
            }
        } else {
            this.isShow2D = !this.isShow2D
            this.$refs.gisContent.setDefaultPoint(this.isShow2D);
        }
    },
    //场景区建筑模型显示/隐藏
    showBim() {
        this.isShowBim = !this.isShowBim
    },
    //预览
    handlePreview(index, list) {
        this.previewIndex = index
        this.previewList = list
    },
    //关闭预览
    handleClosePreview() {
        this.previewIndex = -1
        this.previewList = null
    }
  },
  watch: {},
  beforeDestroy: function() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss" scoped>
.digital-wraper {
    position: relative;
    width: 100%;
    height: calc(100vh - 80px);
}
.digital-wraper-fullscreen {
    position: relative;
    width: 100%;
    height: 100vh;
}
.digital-left {
    position: absolute;
    left: 0;
    top: 0;
    width: 300px;
    height: 100%;
    background: rgba(7, 17, 41, 0.85);
    padding: 10px;
    z-index: 10;
    .left-title {
        font-size: 24px;
        font-family: SourceHanSansCN-Bold;
        color: #FFF;
        font-weight: bold;
        margin: 20px 0 12px 20px;
    }
    .left-search-input {
        position: relative;
        width: 268px;
        height: 36px;
        margin-left: 5px;
        margin-bottom: 20px;
        /deep/ .el-input {
            font-size: 16px;
            height: 36px;
        }
        /deep/ .el-input__inner {
            color: #fff;
            background-color: rgba(255, 255, 255, 0.1);
            border-radius: 3px;
            border: none;
        }
        /**
        *修改input清空按钮
        **/
        /deep/ .el-input__suffix {
            .el-input__suffix-inner {
            border-color: none;
            .el-icon-circle-close:before {
                content: url("../../assets/images/digital/icon-clear.png") !important;
                width: 18px;
                height: 18px;
                position: absolute;
                right: 34px;
                top: 5px;
            }
            }
        }
        .btn-search {
            position: absolute;
            top: 12px;
            right: 10px;
            width: 18px;
            height: 18px;
            background-repeat: no-repeat;
            background-image: url("../../assets/images/digital/icon-search.png");
            background-size: 100%;
            cursor: pointer;
        }
    }
    .left-tree {
        width: 100%;
        height: calc(100vh - 240px);
        overflow-y: auto;
        .tree {
            background: transparent;
            color: #fff;
            /deep/ .el-tree-node {
                white-space: normal;
                .el-tree-node__content {
                    height: 100%;
                }
            }
            .custom-tree-node {
                font-size: 16px;
                font-weight: 500;
                font-family: SourceHanSansCN-Medium;
                margin: 4px 0;
                display: flex;
                .lotnumber {
                    width: 94px;
                    white-space: nowrap;
                }
                .name {
                    flex: 1;
                    line-height: 24px;
                    word-wrap: break-word;
                }
            }
        }
    }
    .search-list {
        width: 100%;
        height: calc(100vh - 260px);
        overflow-y: auto;
        .result {
            width: 100%;
            font-size: 16px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: #FFFFFF;
            padding: 0 6px;
            margin: 6px 0;
            display: flex;
            cursor: pointer;
            .lotnumber {
                width: 94px;
            }
            .name {
                flex: 1;
                line-height: 24px;
                word-wrap: break-word;
            }
        }
    }
}
.digital-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 300px;
    max-height: 80%;
    background: rgba(41, 53, 73, 0.85);
    border-radius: 2px;
    padding: 20px;
    z-index: 10;
}
.digital-menubar {
    position: absolute;
    bottom: 10px;
    width: 600px;
    height: 56px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(7, 17, 41, 0.85);
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 6px;
    font-size: 16px;
    font-family: SourceHanSansCN-Bold;
    color: #FFF;
    font-weight: bold;
    z-index: 10;
    .tab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 100%;
        cursor: pointer;
        border-radius: 3px;
    }
    .tab-item-active {
        background: linear-gradient(180deg, rgba(27, 109, 183, 0), rgba(27, 109, 183, 0.72));
    }
}
.digital-toolbar {
    position: absolute;
    width: 48px;
    height: 104px;
    right: 10px;
    bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    z-index: 10;
    .tool-item {
        width: 48px;
        height: 48px;
        background: #1B6DB7;
        border-radius: 3px;
        cursor: pointer;
    }
    .tool-item1 {
        background: rgba(7, 17, 41, 0.85);
    }
}
</style>
<style lang="scss">
.el-tree-node:focus > .el-tree-node__content, .el-tree-node:hover > .el-tree-node__content {
    background-color: transparent;
}
.el-tree-node:focus > .el-tree-node__content {
  color: #2899FF !important;
}
.is-current > .el-tree-node__content {
  color: #2899FF !important;
}
/**
*修改tree箭头按钮
**/
.el-icon-caret-right:before {
    font-size: 20px;
}
</style>